module.exports = __webpack_public_path__ + "ff4147e82a2d1610fbf59604b7719fa6.png";